function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.8279 20.6221C17.509 21.5327 18.378 22.2861 19.3759 22.8313C20.3738 23.3765 21.4773 23.7007 22.6115 23.782C23.7458 23.8632 24.8842 23.6995 25.9496 23.3021C27.015 22.9047 27.9825 22.2828 28.7865 21.4785L33.5445 16.7205C34.9891 15.2248 35.7884 13.2217 35.7703 11.1424C35.7522 9.06319 34.9182 7.07423 33.4479 5.60392C31.9776 4.13362 29.9886 3.29962 27.9094 3.28155C25.8302 3.26348 23.827 4.06279 22.3314 5.50732L19.6034 8.21941",
  stroke: "#487C71",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M23.172 17.4497C22.4908 16.5391 21.6218 15.7856 20.6239 15.2404C19.626 14.6952 18.5225 14.371 17.3883 14.2898C16.2541 14.2086 15.1156 14.3722 14.0502 14.7696C12.9848 15.1671 12.0173 15.789 11.2134 16.5932L6.45532 21.3513C5.01079 22.8469 4.21148 24.8501 4.22955 26.9293C4.24762 29.0086 5.08162 30.9975 6.55192 32.4678C8.02222 33.9381 10.0112 34.7721 12.0904 34.7902C14.1697 34.8083 16.1728 34.009 17.6685 32.5644L20.3806 29.8523",
  stroke: "#487C71",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgLinkNegative(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkNegative);
export default __webpack_public_path__ + "static/media/link-negative.9e386d64.svg";
export { ForwardRef as ReactComponent };